import React from 'react';
import './DynamicUpdateNotice.css';

// 动态更新提示（全站统一文案，只在此组件维护）
// 定位：认知更新说明；与「DEMO 演示数据｜数据截至」的数据状态标注是两回事，不要合并
// 样式：轻量 Info Notice，小字号、弱背景、低视觉权重；禁止弹窗/警告条/大Banner

export const DYNAMIC_UPDATE_TEXT = '策略与素材建议会随投放数据持续更新；产品事实与合规信息以当前已确认版本为准。';

const DynamicUpdateNotice: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`dynamic-update-notice ${className || ''}`}>
    <span className="dun-icon" aria-hidden="true">ⓘ</span>
    <span className="dun-text">{DYNAMIC_UPDATE_TEXT}</span>
  </div>
);

export default DynamicUpdateNotice;
